import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ApiDocsService {
    constructor(private httpClient: HttpClient) {
    }

    get(url: string) {
      let headers = new HttpHeaders();
      let gcpToken;
      if(localStorage.getItem("gcpToken")!=null)
        gcpToken=localStorage.getItem("gcpToken");

      headers= headers.set('Authorization', "Bearer "+gcpToken); 
      headers=headers.set('Content-Type', 'application/octet-stream');
      return this.httpClient.get(url, { headers }).toPromise();
    }
}
